import { Language, isValidLanguage } from '@/utils/language'
import { Currency, isValidCurrency } from '@/utils/currency'
import { Region, isValidRegion } from '@/utils/region'
import { backendCodeProcessor } from '@/api/request'

const generateCookies = async ({
  acceptLanguage = '',
  languageFromCookie = '',
  currencyFromCookie = '',
  regionFromCookie = '',
  token = ''
}) => {
  const defaultLanguage = acceptLanguage.startsWith(Language.zhCN) ? Language.zhCN : Language.enUS
  const language = isValidLanguage(languageFromCookie) ? languageFromCookie : defaultLanguage
  const currency = isValidCurrency(currencyFromCookie) ? currencyFromCookie : Currency.US
  const region = isValidRegion(regionFromCookie) ? regionFromCookie : Region.US

  return {
    language,
    currency,
    region
  }
}

export default generateCookies
